import React from 'react';

function ModernModal({ isOpen, onClose, title, children, size = 'lg' }) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="overlay"
      onClick={handleBackdropClick}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className={`modal-modern modal-${size}`}>
        {/* Header do modal */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0 fw-bold" id="modal-title">
            {title}
          </h5>
          <button
            type="button"
            className="btn btn-link p-2"
            onClick={onClose}
            aria-label="Fechar modal"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* Conteúdo do modal */}
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

// Modal específico para detalhes do produto
export function ProductDetailModal({ isOpen, onClose, produto, onAddToCart }) {
  if (!produto) return null;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  };

  const hasDiscount = produto.props?.preco < produto.props?.preco_orig;

  return (
    <ModernModal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="Detalhes do Produto"
      size="lg"
    >
      <div className="row">
        {/* Imagem do produto */}
        <div className="col-md-6 mb-3">
          <div className="product-image">
            <img
              src={produto.props?.img || '/placeholder-image.jpg'}
              alt={produto.props?.detalhes?.DESC_PRODUTO || 'Produto'}
              className="img-fluid rounded"
              style={{ width: '100%', height: '300px', objectFit: 'cover' }}
            />
          </div>
        </div>

        {/* Detalhes do produto */}
        <div className="col-md-6">
          <h4 className="fw-bold mb-3">
            {produto.props?.detalhes?.DESC_PRODUTO || 'Produto sem nome'}
          </h4>

          <div className="mb-3">
            <span className="badge bg-secondary">
              {produto.props?.detalhes?.GRUPO_PRODUTO || 'Categoria não informada'}
            </span>
          </div>

          {/* Detalhes técnicos */}
          <div className="mb-4">
            {produto.props?.detalhes?.DESC_COR_PRODUTO && (
              <div className="mb-2">
                <strong>Cor:</strong> {produto.props.detalhes.DESC_COR_PRODUTO}
              </div>
            )}
            {produto.props?.detalhes?.TAMANHO && (
              <div className="mb-2">
                <strong>Tamanho:</strong> {produto.props.detalhes.TAMANHO}
              </div>
            )}
            {produto.props?.estoque && (
              <div className="mb-2">
                <strong>Estoque:</strong> 
                <span className={produto.props.estoque < 5 ? 'text-warning' : 'text-success'}>
                  {produto.props.estoque} unidades
                </span>
              </div>
            )}
          </div>

          {/* Preços */}
          <div className="mb-4">
            {hasDiscount && (
              <div className="mb-1">
                <span className="text-muted text-decoration-line-through">
                  De: {formatPrice(produto.props.preco_orig)}
                </span>
              </div>
            )}
            <div className="price-display d-inline-block">
              {formatPrice(produto.props?.preco || 0)}
            </div>
            {hasDiscount && (
              <div className="mt-1">
                <small className="text-success">
                  Economia de {formatPrice(produto.props.preco_orig - produto.props.preco)}
                </small>
              </div>
            )}
          </div>

          {/* Ações */}
          <div className="d-grid gap-2">
            <button
              className="btn btn-modern"
              onClick={() => onAddToCart(produto)}
              disabled={!produto.props?.estoque}
            >
              <i className="bi bi-cart-plus me-2"></i>
              {produto.props?.estoque ? 'Adicionar ao Carrinho' : 'Produto sem estoque'}
            </button>
            
            <button
              className="btn btn-outline-modern"
              onClick={() => {
                // Adicionar aos favoritos
                console.log('Adicionar aos favoritos:', produto);
              }}
            >
              <i className="bi bi-heart me-2"></i>
              Adicionar aos Favoritos
            </button>
          </div>
        </div>
      </div>

      {/* Informações adicionais */}
      <div className="mt-4">
        <h6 className="fw-bold">Informações do Produto</h6>
        <div className="row">
          <div className="col-md-4">
            <small className="text-muted">Código do Produto</small>
            <div>{produto.id || 'N/A'}</div>
          </div>
          <div className="col-md-4">
            <small className="text-muted">Disponibilidade</small>
            <div className={produto.props?.estoque > 0 ? 'text-success' : 'text-danger'}>
              {produto.props?.estoque > 0 ? 'Em estoque' : 'Indisponível'}
            </div>
          </div>
          <div className="col-md-4">
            <small className="text-muted">Categoria</small>
            <div>{produto.props?.detalhes?.GRUPO_PRODUTO || 'Não informada'}</div>
          </div>
        </div>
      </div>
    </ModernModal>
  );
}

export default ModernModal;
